<template>
	<div class="page">
		<div class="background"></div>
		<v-container class="content ma-n4 ma-sm-n8 pa-0" fluid>

			<v-row class="flex-column flex-sm-row" no-gutters style="min-height: 100vh;">
				<v-col
						align-self="stretch"
						class="info-container"
						cols="12"
						sm="5"
				>
					<div class="align-center d-flex info-inner px-4 pa-sm-8">
						<v-row>
							<v-col class="d-flex flex-column white--text">
								<v-img
										:class="{
										'my-4': $vuetify.breakpoint.xsOnly,
										'ms-n3': $vuetify.breakpoint.xsOnly || $vuetify.breakpoint.mdAndUp,
										'ms-n2': $vuetify.breakpoint.smOnly,
										'align-self-center': $vuetify.breakpoint.xsOnly
									}"
										:max-width="logoWidth"
										src="/images/logo_bw_white.svg"
								></v-img>
								<div v-if="$vuetify.breakpoint.smAndUp">
									<h4
											class="font-weight-medium mb-2 mt-8"
											style="line-height: 1.2 !important"
									>
										{{ copy.heading }}
									</h4>
									<template v-for="point in copy.points">
										<div class="mt-12">
											<v-icon color="#ff876f" x-large>{{ point.icon }}</v-icon>
											<div class="font-weight-bold mt-2 text-body-1">
												{{ point.heading }}
											</div>
											<span
													class="opacity-70 text-body-2 white--text"
													style="line-height: 1.2 !important"
											>
												<template v-if="$vuetify.breakpoint.smAndDown">
													{{ point.text.short }}
												</template>
												<template v-else>
													{{ point.text.long }}
												</template>
											</span>
										</div>
									</template>
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
				<v-col
						align-self="stretch"
						class="form-container"
						cols="12"
						sm="7"
				>
					<div class="align-center d-flex form-inner pa-4 pa-sm-8">
						<v-row>
							<v-col class="align-center d-flex flex-column">
								<h1 class="mt-4 mt-sm-0 text-h2 text-sm-h1">Hello, {{ firstName }}!</h1>
								<p
										class="grey--text text--darken-1 mt-4 mt-sm-8 text-center"
										:class="$vuetify.breakpoint.lgAndUp ? 'text-body-1' : 'text-body-2'"
								>
									<strong>{{ venue.name }}</strong> has been selected to take part in the
									<strong>{{ invite.name }}</strong>
									program by
									<strong>{{ invite.partnerName }}.</strong>
									Getting started is as easy as accepting the invite to the program and
									confirming a few details about your business.
								</p>

								<div
										v-if="'this is' === 'needed'"
										class="d-flex justify-space-around mb-8 mt-4 px-12 w-100"
								>
									<span class="font-weight-bold">point 1</span>
									<span class="font-weight-bold">point 2</span>
									<span class="font-weight-bold">point 3</span>
								</div>

								<div class="mt-4 mt-sm-8">
									<v-btn
											class="me-2 rounded-lg"
											color="grey darken-1"
											depressed
											:large="$vuetify.breakpoint.smAndDown"
											:loading="loading"
											outlined
											:x-large="$vuetify.breakpoint.mdAndUp"
											@click.stop="showDeclineReasons = true"
									>
										Decline
									</v-btn>
									<v-btn
											class="rounded-lg"
											color="primary"
											depressed
											:large="$vuetify.breakpoint.smAndDown"
											:loading="loading"
											:x-large="$vuetify.breakpoint.mdAndUp"
											@click.stop="submitInvite('in_progress')"
									>
										Accept
									</v-btn>
								</div>

								<v-progress-linear
										v-if="loading"
										class="mb-8 mt-12 w-100"
										color="secondary"
										height="2"
										indeterminate
								></v-progress-linear>
								<v-divider v-if="!loading" class="mb-8 mt-12 w-100"></v-divider>

								<div class="w-100">
									<invite-avatars
											:activeAvatar="activeAvatar"
											:avatarSize="$vuetify.breakpoint.smAndDown ? 36 : 48"
											grayscale
											:invite="invite"
											:invitees="invitees"
											@set-active-avatar="setActiveAvatar"
									>
										<template v-slot:header>
											<h5 class="font-weight-light mb-4 text-center">Who's Here So
												Far</h5>
										</template>
										<template v-slot:footer>
											<v-divider class="my-8 w-100"></v-divider>
										</template>
									</invite-avatars>
								</div>

								<h6 class="mb-4">A Little About The Pass</h6>
								<div
										class="grey--text text-center text--darken-1 text-body-2"
										:inner-html.prop="invite.description"
								></div>
								<v-divider class="mb-4 mt-12 w-100"></v-divider>
								<div class="grey--text text-center" style="font-size: 10px;">
									<strong>About Bandwango</strong> - Bandwango is a technology company
									based out of Murray, Utah with more than 400 clients across the United
									States and Canada. Bandwango’s signature product enables clients to
									curate free and paid experiences into passports, trails and marketplaces
									designed to deliver the best tickets, tours and savings to locals and
									visitors alike. DXE is an end-to-end solution that combines anywhere
									merchant and inventory management, redemption technology, white-labeled
									mobile web application delivery, customer service, managed accounting,
									and true economic impact data to provide a seamless solution to
									destination marketing organizations, associations and other industry
									partners.
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
			</v-row>

		</v-container>

		<v-dialog
				v-model="showDeclineReasons"
				content-class="rounded-xl"
				persistent
				scrollable
				width="600px"
		>
			<v-form v-model="formIsValid" ref="frm">
				<v-card class="position-relative" rounded="xl">
					<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
						<div class="w-100">
							<div class="align-center d-flex justify-space-between">
								<h6>Invitation Declined</h6>
								<v-btn
										class="mt-n1 me-n2"
										color="black"
										depressed
										icon
										@click="showDeclineReasons = false"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
					</v-card-title>
					<v-card-text class="text-body-2">

						Do you mind letting us know why you have declined this invitation to
						participate
						in the <strong>{{ invite.name }}</strong> program by
						<strong>{{ invite.partnerName }}</strong>.

						<v-divider class="mb-8 mt-4 opacity-70"></v-divider>

						<v-row>
							<v-col>
								<v-select
										v-model="customFields.bw_invite_decline_reason.value"
										class="required rounded-lg"
										hide-details="auto"
										label="Decline Invite Reason"
										:items="[
											'I don\'t know this organization',
											'I don\'t see the value in participating',
											'I\'m not interested in this specific campaign',
											'My business is closed',
											'Other'
										]"
										outlined
										:rules="rules.declineReason"
								>
								</v-select>
							</v-col>
						</v-row>

						<v-row v-if="customFields.bw_invite_decline_reason.value === 'Other'">
							<v-col>
								<v-textarea
										v-model="customFields.bw_invite_decline_reason_comment.value"
										auto-grow
										class="required rounded-lg"
										counter="250"
										hint=""
										label="Comments"
										outlined
										persistent-hint
										rows="4"
										:rules="rules.comment"
								></v-textarea>
							</v-col>
						</v-row>

					</v-card-text>

					<v-card-actions>
						<div class="align-center d-flex justify-space-between w-100">
							<span></span>
							<div class="d-flex justify-end">
								<v-btn
										class="me-2 me-md-4 rounded-lg"
										color="grey darken-1"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										outlined
										@click="submitInvite()"
								>
									No Thanks
								</v-btn>
								<v-btn
										class="rounded-lg"
										color="primary"
										:disabled="!formIsValid"
										depressed
										:large="$vuetify.breakpoint.mdAndUp"
										@click="submitInvite()"
								>
									Submit
								</v-btn>
							</div>
						</div>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

	</div>
</template>

<script>
import { inviteHelpers } from '../../../Shared/helpers';

export default {
	name: 'Landing',
	props: {
		invite: {
			type: Object,
			default: () => ({})
		},
		user: {
			type: Object,
			default: () => ({})
		},
		venue: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			activeAvatar: 0,
			copy: {
				heading: 'Join A Unique Experience Passport In Your Community.',
				points: [
					{
						heading: 'Increased Exposure',
						text: {
							long: 'Joining a pass on Bandwango expands a merchant\'s reach to a wider audience, leading to increased foot traffic, sales, and brand awareness.',
							short: 'Joining a Bandwango pass expands reach to a wider audience, leading to more traffic, sales & brand awareness.'
						},
						icon: 'mdi-bullhorn-outline'
					},
					{
						heading: 'Targeted Marketing',
						text: {
							long: 'Bandwango enables merchants to offer customized deals to specific audiences, increasing the chances of converting them into loyal customers.',
							short: 'Bandwango enables customized deals to specific audiences, increasing chances of converting them to loyal customers.'
						},
						icon: 'mdi-bullseye-arrow'
					},
					{
						heading: 'Data Insights',
						text: {
							long: 'Merchants are provided with valuable data on customer behavior, helping them optimize marketing strategies, improve customer experience, and make data-driven decisions.',
							short: 'Bandwango provides merchants with valuable data on customer behavior, optimizing marketing & customer experience.'
						},
						icon: 'mdi-database-outline'
					}
				]
			},
			formIsValid: false,
			inviteHelpers,
			invitees: inviteHelpers.nonDeclinedInvitees(this.invite),
			loading: false,
			rules: {
				declineReason: [v => !!v || 'Decline reason is required.'],
				comment: [v => !!v || 'Comment is required.']
			},
			showDeclineReasons: false,
			customFields: {
				bw_invite_decline_reason: {
					value: "",
				},
				bw_invite_decline_reason_comment: {
					value: "",
				},
			},
		};
	},
	computed: {
		firstName() {
			return this.user.name?.trim() ? this.user.name.trim().split(' ')[0] : 'Friend';
		},
		logoWidth() {
			if(this.$vuetify.breakpoint.xsOnly) return 144; // height = 80
			if(this.$vuetify.breakpoint.mdAndUp) return 180;
			return 120;
		}
	},
	created() {
	},
	methods: {
		submitInvite(status = 'declined') {
			this.loading = true;

			let queryString = '';
			if(this.showDeclineReasons)
				queryString = Object.keys(this.customFields).map(x => 'customFields[' + x + ']=' + this.customFields[x].value).join('&');
			window.userpilot?.track(`campaign_landing_click_${status}`, {campaign_id: this.invite.id});
			window.location.href = `/merchant-portal/${this.venue.id}/invites/view/submit-landing/${this.invite.id}?status=${status}&${queryString}`;
		},
		setActiveAvatar(idx) {
			this.activeAvatar = idx;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables'; // breakpoints

.page {
	position: relative;
}

.background {
	background-image: url('/images/portals/welcome-alert-bg.jpg');
	background-position: center center;
	background-size: cover;
	bottom: 0;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	transform: rotate(180deg) scaleX(-1);
	z-index: 1;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		transform: scaleY(-1);
	}
}

.content {
	min-height: 100vh;
	min-width: 100vw;
	position: relative;
	z-index: 2;
}

.info-container {
}

.info-inner {
	backdrop-filter: blur(30px);
	background: rgba(255, 255, 255, 0.1);
	border-top-left-radius: map-get($rounded, 'xl');
	border-bottom-left-radius: map-get($rounded, 'xl');
	box-shadow: 0 12px 76px 3px rgba(47, 68, 104, 0.28),
	0 5px 92px 8px rgba(47, 68, 104, 0.24), 0 6px 30px 0 rgba(47, 68, 104, 0.4); //rgb(0 67 133)
	height: calc(100% - 10vh);
	margin: 5vh 0 5vh 5vw;
	min-height: 90vh;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		border-bottom-left-radius: 0;
		border-top-right-radius: map-get($rounded, 'xl');
		height: auto;
		margin: 5vh 5vw 0 5vw;
		min-height: calc(60px + 2rem);
	}

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		margin-left: 10vw;
	}

	@media #{map-get($display-breakpoints, 'lg-and-up')} {
		margin-left: 20vw;
	}

	& .v-icon::before {
		filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
	}
}

.form-container {
	background-color: rgba(255, 255, 255, 0.6);
	z-index: 1;
}

.form-inner {
	background: rgba(255, 255, 255, 0.9);
	border-top-right-radius: map-get($rounded, 'xl');
	border-bottom-right-radius: map-get($rounded, 'xl');
	box-shadow: 0 12px 76px 3px rgba(100, 136, 170, 0.14),
	0 5px 92px 8px rgba(100, 136, 170, 0.12), 0 6px 30px 0 rgba(100, 136, 170, 0.2); //rgb(0 67 133)
	height: calc(100% - 10vh);
	margin: 5vh 5vw 5vh 0;
	min-height: 90vh;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		border-bottom-left-radius: map-get($rounded, 'xl');
		border-top-right-radius: 0;
		height: auto;
		margin: 0 5vw 5vh 5vw;
		min-height: calc(90vh - 60px - 2rem);
	}

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		margin-right: 10vw;
	}

	@media #{map-get($display-breakpoints, 'lg-and-up')} {
		margin-right: 20vw;
	}

	@media #{map-get($display-breakpoints, 'xl-only')} {
		margin-right: 30vw;
	}
}
</style>
